import {AutowiredHttp} from 'utils/AutoWrite.js'
import { passwordUrl } from 'config/urlConfig.js'

@AutowiredHttp

class updatePasswordService {
  constructor(){}
  // 发送验证码
  static async sendCode(urlType,data){
    try {
      let queryUrl = passwordUrl[urlType]
      let queryData = data
      let ret = await updatePasswordService.ajaxInstance.post(queryUrl,queryData)
      return {vueData: ret.data, state: ret.state || {code:'000'}}
    }catch(err) {
      console.log( 'updatePassword is err: ', err )
    }
  }
  // 修改密码
  static async updatePassword(urlType,body){
    try {
      let queryUrl = passwordUrl[urlType]
      let user = {
        opass: body.oldPwd,
        npass: body.newPwd1,
      }
      let ret = await updatePasswordService.ajaxInstance.post(queryUrl,user)
      return ret.state || {code:'000'}
    }catch(err) {
      console.log( 'updatePassword is err: ', err )
    }
  }
}
export default updatePasswordService



// WEBPACK FOOTER //
// ./src/business/updatePasswordService.js